import { connect } from 'react-redux'
import LineModule from '../Modules/Line'
import { AUTHEN_TOKEN } from '../../../constants/define'
import { getUsedStampHistory } from '../../../api/analytic'

class LineUsedStamp extends LineModule {
  getAuthenToken = () => {
    return localStorage.getItem(AUTHEN_TOKEN)
  }

  callApi = (...arg) => {
    return getUsedStampHistory(...arg)
  }

  getTitle = () => {
    const language = this.getLanguage()
    return language.t('dashboard.used_stamp')
  }

  getLanguage = () => {
    const { language } = this.props
    return language
  }
}

const mapState = state => {
  return {
    language: state.languageReducer.language,
  }
}

export default connect(mapState)(LineUsedStamp)
